import { render, staticRenderFns } from "./ErrorReportDialog.vue?vue&type=template&id=8d670370&scoped=true"
import script from "./ErrorReportDialog.vue?vue&type=script&lang=js"
export * from "./ErrorReportDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorReportDialog.vue?vue&type=style&index=0&id=8d670370&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d670370",
  null
  
)

export default component.exports